import { connectedStore } from '../../store';
import selectors from '../selectors';

const getCustomTextColors = () => {
  const store = connectedStore.get();
  const state = store.getState();

  return selectors.getCustomTextColors(state);
};

export default getCustomTextColors;
